module.exports = __webpack_public_path__ + "img/progress.a6187bfb.svg";